// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".category-icons[data-v-a1c67e60]{align-items:center;display:flex;justify-content:center}img[data-v-a1c67e60]{height:1.25em;vertical-align:bottom;width:auto}.category-icons img~img[data-v-a1c67e60]{margin-left:.4em}.category-icon~.touring-pitches[data-v-a1c67e60]{margin-left:.25em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
